import React from 'react'
import { Checkbox } from 'antd'
import { getColorByIndex, hexToRgba } from '../../../../utils/colors.helper'
import { isNil } from 'lodash'
import { primaryColor } from '../../../../constants/styles'

const compareMotifSize = (a, b) => {
    if (a.end_row - a.start_row > b.end_row - b.start_row) {
        return -1
    }
    if (a.end_row - a.start_row < b.end_row - b.start_row) {
        return 1
    }
    return 0
}

const FILE_CARD_HEIGHT_IN_PX = 72

const FileCard = ({ id, name, isOpened, isSelected, onClick, onCheckboxChange, patternsVisualisation, overlayIcon, overlayBackgroundColor }) => {
    let patternsVisualisationElements
    if (patternsVisualisation) {
        const countOfLines = patternsVisualisation.size
        const lineSizeInPx = FILE_CARD_HEIGHT_IN_PX / countOfLines

        const patterns = patternsVisualisation.items.sort(compareMotifSize)

        patternsVisualisationElements = patterns.map((pattern, patternIndex) => {
            if (isNil(pattern.start_row) || isNil(pattern.end_row)) return
            let levelOfNestity = 0
            const distanceToTopInPx = (pattern.start_row - 1) * lineSizeInPx
            const heightInLines = pattern.end_row - pattern.start_row + 1
            const heightInPx = Math.max(heightInLines * lineSizeInPx, 1)
            patterns.map((patternToCompare, patternToCompareIndex) => {
                const patternsExactlyTheSame =
                    pattern.start_row === patternToCompare.start_row && pattern.end_row === patternToCompare.end_row
                if (patternsExactlyTheSame) {
                    if (patternToCompareIndex < patternIndex) levelOfNestity++
                    return
                }

                const patternIsNotTheSame = pattern.motif_id !== patternToCompare.motif_id
                const patternStartsFurtherStart = pattern.start_row >= patternToCompare.start_row
                const patternStartsBeforeEnd = pattern.start_row <= patternToCompare.end_row
                const patternIsSmaller =
                    pattern.end_row - pattern.start_row < patternToCompare.end_row - patternToCompare.start_row

                if (patternIsNotTheSame && patternStartsFurtherStart && patternStartsBeforeEnd && patternIsSmaller)
                    levelOfNestity++
            })

            let width
            if (levelOfNestity === 0) width = '100%'
            else if (levelOfNestity === 1) width = '80%'
            else if (levelOfNestity === 2) width = '60%'
            else if (levelOfNestity === 3) width = '40%'
            else width = '20%'

            return (
                <div
                    key={patternIndex}
                    className='cluster__file-card-pattern'
                    style={{
                        height: heightInPx,
                        width: width,
                        top: distanceToTopInPx,
                        background: getColorByIndex(pattern.color_id).value,
                        borderRadius: 6,
                    }}
                />
            )
        })
    }

    return (
        <button
            id={`cluster__file-card-${id}`}
            className='cluster__file-card'
            data-selected-card={isOpened || isSelected ? 'true' : undefined}
            onClick={onClick}
            title={`file ${name}`}
            aria-label={`file ${name}`}
            aria-haspopup='true'
            style={{
                position: 'relative',
                ...(overlayIcon && {
                    backgroundColor: overlayBackgroundColor 
                        ? `${hexToRgba(overlayBackgroundColor, 0.8)}` 
                        : `${primaryColor}`
                })
            }}
        >
            {onCheckboxChange && (
                <Checkbox
                    className='cluster__file-card-checkbox'
                    checked={isSelected}
                    onClick={event => event.stopPropagation()}
                    onChange={onCheckboxChange}
                    aria-label='select file'
                    title='select file'
                >
                    <div>select file</div>
                </Checkbox>
            )}
            {patternsVisualisationElements}
            {overlayIcon && (
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '24px',
                        color: 'white',
                        zIndex: 10,
                        textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                        pointerEvents: 'none'
                    }}
                >
                    {overlayIcon}
                </div>
            )}
        </button>
    )
}

export default FileCard
